<div class="grid__col-12">
  @if (memberCounts) {
    <dgx-member-counts
      [memberCounts]="memberCounts"
      [isStandaloneOrg]="isStandaloneOrg"
    ></dgx-member-counts>
  }
</div>
<div class="grid__col-12">
  <dgx-org-members-header
    [orgId]="orgId"
    [canInviteMembers]="canInviteMembers"
    (updateQueries)="doSearch($event)"
  ></dgx-org-members-header>
</div>
<dgx-data-table
  [columns]="columns"
  [useSkeleton]="true"
  [items]="members"
  (loadMoreItems)="getMembers()"
  [isLoading]="isLoading"
  propTrackingKey="userProfileKey"
  [isSorting]="isSorting"
  [isDescending]="isDescending"
  [orderBy]="orderBy"
  (updateSort)="updateSort($event)"
  [hasNoResults]="hasNoResults"
  [hasNoItems]="false"
  [searchTerm]="searchTerm"
  [numResultsPerPage]="take"
  [pageNum]="pageNum"
  [showPerPage]="true"
  [perPageOptions]="[
    { value: 10, display: '10' },
    { value: 30, display: '30' },
    { value: 50, display: '50' },
  ]"
  [totalNumResults]="visibleMembersTotal"
  (pageChange)="updatePagination({ currentPage: $event })"
  (perPageChange)="updatePagination({ pageSize: $event })"
>
</dgx-data-table>

<dgx-footer-glasses></dgx-footer-glasses>

<ng-template #profile let-item>
  <div class="l_flexbar">
    <div class="ib ib-v-middle">
      <dgx-profile-pic [profile]="item" size="tiny"></dgx-profile-pic>
    </div>
    <div class="guts-p-l-1">
      @switch (item.privacyId) {
        @case ('Private') {
          <span class="guts-m-r-half">{{ item.name }}</span>
        }
        @default {
          <a
            target="_blank"
            [attr.href]="'/profile/' + item.vanityUrl"
            class="guts-m-r-half uhover color-ebony"
            data-dgat="orgMembers-4bc"
            >{{ item.name }}
          </a>
        }
      }
      <div class="guts-m-r-half par par--small par--light">
        {{ item.organizationEmail }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #roleDisplay let-item>
  <dgx-badge-list [items]="getRoleStrings(item.roles)"></dgx-badge-list>
</ng-template>

<ng-template #privacyDisplay let-item>
  <div>
    @switch (item.privacyId) {
      @case ('Public') {
        <div>
          <div>{{ i18n.OrgMembersCtrl_Public }}</div>
          <div class="par--small par--light">
            {{ i18n.OrgMembersCtrl_PublicTooltip }}
          </div>
        </div>
      }
      @case ('OrgVisible') {
        <div>
          <div>{{ i18n.OrgMembersCtrl_PrivateToOrg }}</div>
          <div class="par--small par--light">
            {{ i18n.OrgMembersCtrl_PublicToOrgTooltip }}
          </div>
        </div>
      }
      @case ('Private') {
        <div>
          <div>{{ i18n.OrgMembersCtrl_Private }}</div>
          <div class="par--small par--light">
            {{ i18n.OrgMembersCtrl_PrivateTooltip }}
          </div>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #pointsDisplay let-item>
  {{ item.masteryPoints ? (item.masteryPoints | number: '1.0-0') : '0' }}
</ng-template>

<ng-template #statusDisplay let-item>
  {{ getStatusString(item.status) }}
</ng-template>

<ng-template #editMember let-item>
  @if (canEditMember(item)) {
    <button
      class="beta color-ebony-a61"
      type="button"
      [title]="i18n.OrgMembersCtrl_MemberSettingsText"
      [attr.aria-label]="i18n.OrgMembersCtrl_MemberSettingsText"
      (click)="openMember(item)"
      data-dgat="orgMembers-64d"
    >
      <da-icon
        icon="cog-6-tooth"
        type="solid-small"
        class="tw-reset tw-inline-block tw-align-middle"
      ></da-icon>
    </button>
  }
</ng-template>
